import FormInviteUser from './form-invite-user'

export default FormInviteUser
